module.exports = __webpack_public_path__ + "static/media/ArchivedFolderFilesFolder.9025a30d.svg";